import React, { useContext, useState } from 'react'
import AuthContext from '../../context/auth/authContext'
import SubmitForm from './SubmitForm'
import Inputmask from 'inputmask'
import $ from 'jquery';
import toastr from 'toastr'
import Select from 'react-select'
import makeAnimated from 'react-select/animated';
import selectStyles from './selectStyles.js'
function Step7({ validateField }) {
    setTimeout(() => {
        const arr = document.querySelectorAll('[data-inputmask]');
        Inputmask({ 'placeholder': '' }).mask(arr);
    }, 500);
    const authContext = useContext(AuthContext);
    let { lead, gotoNextStep, step } = authContext;
    const initialState = {
        business_type: lead.business_type ? lead.business_type : '',
        business_active_years: lead.business_active_years ? lead.business_active_years : '',
        business_active_months: lead.business_active_months ? lead.business_active_months : '',
        business_product_sold: lead.business_product_sold ? lead.business_product_sold : '',
        business_avrg_sale_amount: lead.business_avrg_sale_amount ? lead.business_avrg_sale_amount : '',
        business_high_sale_amount: lead.business_high_sale_amount ? lead.business_high_sale_amount : '',
        business_monthly_volume: lead.business_monthly_volume,
        accept_payment_methods: lead.accept_payment_methods ? lead.accept_payment_methods : '',
        website: lead.website ? lead.website : '',
        persistWebsite: lead.accept_payment_methods ? lead.accept_payment_methods.indexOf('Online') != -1 && !lead.website : false
    }

    const [fields, setFields] = useState(initialState);
    const handleChange = (event) => {
        const target = event.target;
        let value = target.value;
        let index = target.name;
        validateField(target);
        if (index == 'website') {
            setFields({
                ...fields, persistWebsite: true
            });
        }
        setFields({
            ...fields, [index]: value
        });
    }
    const handleSubmit = (event) => {
        event.preventDefault();
        const $array = Object.keys(fields);
        const $errorbag = [];
        $array.map((item) => {
            const target = document.getElementsByName(item)[0];
            if (target) {
                let $result = validateField(target);
                if ($result) {
                    $errorbag.push($result);
                }
            }
            return null;
        });
        if ($errorbag.length === 0) {
            gotoNextStep(fields, step);
        } else {
            let $format = '';
            $errorbag.map((error, i) => {
                const $err = error + '<br/>';
                $format += $err;
                return null;
            })
            toastr.error($format);
        }
    }
    const handlePremises = (event) => {
        event.preventDefault();
        let $label = $(event.target),
            $element = $label.find('input'),
            $value = $element.val();
        $element.parent().addClass('active').siblings('.btn').removeClass('active');
        $('#biz_col').removeClass('is-invalid');
        setFields({
            ...fields, business_type: $value
        });

    }
    const handleSelect = (e) => {
        // console.log(e);
        var $arr = [];
        e.forEach((i) => {
            $arr.push(i.value);
        });
        let $showWebsite = false;
        if ($arr.indexOf('Online') != -1 && !fields.website) {
            $showWebsite = true;
        }
        setFields({
            ...fields, accept_payment_methods: $arr,
            persistWebsite: $showWebsite
        });
    }
    const defaultCheckedMethods = [];
    if (fields.accept_payment_methods) {
        fields.accept_payment_methods.forEach((item) => {
            let $i = {
                value: item, label: item
            }
            defaultCheckedMethods.push($i);
        })

    }

    const animatedComponents = makeAnimated();
    const customStyles = selectStyles;
    const $premises = ['Storefront Location', 'Office', 'Home Business', 'Mobile'];
    const $checkIfDefined = ($var) => {
        var $result = true;
        if (typeof $var == 'undefined') {
            $result = false;
        }
        if ($result) {
            return $var;
        }
        return '';
    }
    return (
        <>
            <form onSubmit={e => handleSubmit(e)}>
                <div className="container">
                    <div className="row">
                        <div className="mb-3 col-md-12" id="biz_col">
                            <label htmlFor="">Description of Business Premises</label>
                            <div className="btn-toggle d-block business_btns" data-toggle="buttons">
                                {
                                    $premises.map((item, i) => {
                                        return (
                                            <label key={i}
                                                className={"btn btn-light bg-button " + (fields.business_type && fields.business_type === item ? 'active' : '')} htmlFor={'option' + i} onClick={e => handlePremises(e)}>
                                                <input type="radio"
                                                    onChange={e => console.log('')}
                                                    value={item}
                                                    checked={fields.business_type && fields.business_type == item ? true : false}
                                                    name='business_type'
                                                    id={'option' + i} /> {item}
                                            </label>
                                        )
                                    })

                                }

                            </div>
                        </div>

                        <div className="col-md-6">
                            <label htmlFor="business_product_sold">How long have you been in business?</label>
                            <div className="row">
                                <div className="mb-3 col-6">
                                    <div className="input-group">
                                        <span className="input-group-text"><i className="fas fa-map-pin"></i></span>
                                        <input type="tel" inputMode="numeric" name="business_active_years" placeholder="Year(s)" onChange={e => handleChange(e)}
                                            className="form-control"
                                            value={$checkIfDefined(fields.business_active_years)} />
                                    </div>
                                    <p className="small pb-0 mb-0">*Please input number of years</p>


                                </div>
                                <div className="mb-3 col-6">
                                    <div className="input-group">
                                        <span className="input-group-text"><i className="fas fa-map-pin"></i></span>
                                        <input type="tel" inputMode="numeric" name="business_active_months" placeholder="Month(s)" onChange={e => handleChange(e)}
                                            className="form-control"
                                            value={$checkIfDefined(fields.business_active_months)} />
                                    </div>
                                    <p className="small pb-0 mb-0">*Please input number of months</p>

                                </div>
                            </div>

                        </div>
                        <div className="mb-3 col-md-6">
                            <label htmlFor="business_product_sold">What products or services will you be selling?</label>
                            <div className="input-group">
                                <span className="input-group-text"><i className="fas fa-map-marked-alt"></i></span>
                                <input type="text" name="business_product_sold" onChange={e => handleChange(e)}
                                    className="form-control" value={fields.business_product_sold || ''} />
                            </div>
                        </div>
                        <div className={!fields.persistWebsite ? "mb-3 col-md-12" : "mb-3 col-md-6"}>
                            <label htmlFor="business_high_sale_amount">How do you plan to accept payments?</label>
                            <Select onChange={e => handleSelect(e)}
                                name="accept_payment_methods"
                                closeMenuOnSelect={false}
                                id="accept_payment_methods"
                                styles={customStyles}
                                components={animatedComponents}
                                value={defaultCheckedMethods}
                                isMulti
                                options={[
                                    { value: 'In-Person', label: 'In-Person' },
                                    { value: 'Manually Typed', label: 'Manually Typed' },
                                    { value: 'Online', label: 'Online' },
                                    { value: 'On the Go/Mobile', label: 'On the Go/Mobile' }
                                ]}

                            />
                        </div>
                        {fields.persistWebsite ?

                            < div className="mb-3 col-md-6">
                                <label htmlFor="website">What is your website address?</label>
                                <div className="input-group">
                                    <span className="input-group-text"><i className="fas fa-globe"></i></span>
                                    <input type="text" name="website" required data-required="true" onChange={e => handleChange(e)}
                                        className="form-control website_field" value={fields.website || ''} />
                                </div>
                            </div>
                            : ''}
                        <div className="mb-3 col-md-4">
                            <label htmlFor="business_monthly_volume">Monthly Visa/MC/Discover/Amex volume:</label>
                            <div className="input-group">
                                <span className="input-group-prepend"><span className="input-group-text"><i className="fab fa-cc-discover"></i></span></span>
                                <select className="custom-select" defaultValue={fields.business_monthly_volume || ''} onChange={e => handleChange(e)}
                                    name="business_monthly_volume">
                                    <option value="" disabled>Select...</option>
                                    <option value="$0-$5000">$0-$5000</option>
                                    <option value="$5,000-$10,000">$5,000-$10,000</option>
                                    <option value="$10,000-$20,000">$10,000-$20,000</option>
                                    <option value="$20,000-$30,000">$20,000-$30,000</option>
                                    <option value="$30,000-$50,000">$30,000-$50,000</option>
                                    <option value="$50,000-$75,000">$50,000-$75,000</option>
                                    <option value="$75,000-$100,000">$75,000-$100,000</option>
                                    <option value="$100,000+">$100,000+</option>
                                </select>
                            </div>
                        </div>
                        <div className="mb-3 col-md-4">
                            <label htmlFor="business_avrg_sale_amount">How much will your average credit card sale be?</label>
                            <div className="input-group">
                                <span className="input-group-prepend"><span className="input-group-text"><i className="fab fa-cc-discover"></i></span></span>
                                {/* <select className="custom-select" defaultValue={fields.business_avrg_sale_amount || ''} onChange={e => handleChange(e)}
                                    name="business_avrg_sale_amount">
                                    <option value="" disabled>Select...</option>
                                    <option value="$5-50">$5-50</option>
                                    <option value="$50-$500">$50-$500</option>
                                    <option value="$500-$2000">$500-$2000</option>
                                    <option value="More than $2000">More than $2000</option>
                                    <option value="I am not sure">I am not sure</option>
                                </select> */}
                                <input type="tel" inputMode="numeric" name="business_avrg_sale_amount" placeholder="Enter a value" onChange={e => handleChange(e)}
                                    className="form-control" value={fields.business_avrg_sale_amount || ''} />
                            </div>
                        </div>


                        <div className="mb-3 col-md-4">
                            <label htmlFor="business_high_sale_amount">How much will your highest credit card sale be?</label>
                            <div className="input-group">
                                <span className="input-group-text"><i className="fab fa-cc-discover"></i></span>
                                {/* <select className="custom-select" defaultValue={fields.business_high_sale_amount || ''} onChange={e => handleChange(e)}
                                    name="business_high_sale_amount">
                                    <option value="" disabled>Select...</option>
                                    <option value="$5-50">$5-50</option>
                                    <option value="$50-$500">$50-$500</option>
                                    <option value="$500-$2000">$500-$2000</option>
                                    <option value="More than $2000">More than $2000</option>
                                    <option value="I am not sure">I am not sure</option>
                                </select> */}
                                <input type="tel" inputMode="numeric" placeholder="Enter a value" name="business_high_sale_amount" onChange={e => handleChange(e)}
                                    className="form-control" value={fields.business_high_sale_amount || ''} />
                            </div>
                        </div>

                    </div>

                    <SubmitForm />
                </div >

            </form >
        </>
    )
}

export default Step7
